import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the times of the runs of the allocation (50-api/sales.md §2.6, ADR-186): every warehouse in use with
// its times, all at once.

const schedules = api.sales["allocation-schedules"];

type AllocationSchedules = InferResponseType<typeof schedules.$get, 200>;
export type WarehouseSchedules = AllocationSchedules["warehouses"][number];

const keys = { all: ["allocation-schedules"] as const };

export const allocationScheduleQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: ({ signal }) => unwrap(schedules.$get({}, { init: { signal } })),
    }),
};
